import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartData } from 'chart.js';
import { Chart, registerables } from 'chart.js';

import { AnalysisOptionsComponent } from '../../tools/analysis-options/analysis-options.component';


Chart.register(...registerables);

//Variables del Navegador
type MenuItem = 'summary' | 'charts';

//Variable para expandir cada cuadro
interface ExpandedState {
  [key: string]: boolean;
}

interface WordCount {
  word: string;
  count: number;
}

interface Data {
  [key: string]: WordCount[];
}

interface DividedData {
  [key: string]: WordCount[][];
}

@Component({
  selector: 'metadiscourse-free',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AnalysisOptionsComponent,
    BaseChartDirective],
  templateUrl: './metadiscourse-free.component.html',
  styleUrl: './metadiscourse-free.component.css'
})
export class MetadiscourseFreeComponent {
  selectedMenuItem: MenuItem = 'summary';

  //Valores para expandir cada Cuadro
  public isExpanded: ExpandedState = {
    TOTAL: false,
    ATTITUDE: false,
    EMPHATIC: false,
    EVIDENTIAL: false,
    HEDGE: false,
    LOGICAL: false,
    PERSON: false,
    RELATIONAL: false,
    SEQUENCING: false,
    UNLISTED: false,
  };

  // Variables Pagina 1 Summary
  public datos_pagina_total = {
    types: 16,
    tokens: 24,
  };
  public datos_pagina_attitude = {
    types: 1,
    tokens: 1,
  };
  public datos_pagina_emphatic = {
    types: 2,
    tokens: 3,
  };
  public datos_pagina_evidential = {
    types: 2,
    tokens: 2,
  };
  public datos_pagina_hedge = {
    types: 2,
    tokens: 2,
  };
  public datos_pagina_logical = {
    types: 6,
    tokens: 13,
  };
  public datos_pagina_person = {
    types: 1,
    tokens: 1,
  };
  public datos_pagina_relational = {
    types: 1,
    tokens: 1,
  };
  public datos_pagina_sequencing = {
    types: 1,
    tokens: 1,
  };
  public datos_pagina_unlisted = {
    types: 219,
    tokens: 319,
  };

  // Variables Pagina 1 Summary
  public types_total: number | undefined | null;
  public tokens_total: number | undefined | null;

  public types_attitude: number | undefined | null;
  public tokens_attitude: number | undefined | null;

  public types_emphatic: number | undefined | null;
  public tokens_emphatic: number | undefined | null;

  public types_evidential: number | undefined | null;
  public tokens_evidential: number | undefined | null;

  public types_hedge: number | undefined | null;
  public tokens_hedge: number | undefined | null;

  public types_logical: number | undefined | null;
  public tokens_logical: number | undefined | null;

  public types_person: number | undefined | null;
  public tokens_person: number | undefined | null;

  public types_relational: number | undefined | null;
  public tokens_relational: number | undefined | null;

  public types_sequencing: number | undefined | null;
  public tokens_sequencing: number | undefined | null;

  public types_unlisted: number | undefined | null;
  public tokens_unlisted: number | undefined | null;

  ngOnInit(): void {
    // Variables Pagina 1 Summary
    this.types_total = this.datos_pagina_total.types;
    this.tokens_total = this.datos_pagina_total.tokens;

    this.types_attitude = this.datos_pagina_attitude.types;
    this.tokens_attitude = this.datos_pagina_attitude.tokens;

    this.types_emphatic = this.datos_pagina_emphatic.types;
    this.tokens_emphatic = this.datos_pagina_emphatic.tokens;

    this.types_evidential = this.datos_pagina_evidential.types;
    this.tokens_evidential = this.datos_pagina_evidential.tokens;

    this.types_hedge = this.datos_pagina_hedge.types;
    this.tokens_hedge = this.datos_pagina_hedge.tokens;

    this.types_logical = this.datos_pagina_logical.types;
    this.tokens_logical = this.datos_pagina_logical.tokens;

    this.types_person = this.datos_pagina_person.types;
    this.tokens_person = this.datos_pagina_person.tokens;

    this.types_relational = this.datos_pagina_relational.types;
    this.tokens_relational = this.datos_pagina_relational.tokens;

    this.types_sequencing = this.datos_pagina_sequencing.types;
    this.tokens_sequencing = this.datos_pagina_sequencing.tokens;

    this.types_unlisted = this.datos_pagina_unlisted.types;
    this.tokens_unlisted = this.datos_pagina_unlisted.tokens;

  }

  public data: Data = {
    TOTAL: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    ATTITUDE: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    EMPHATIC: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    EVIDENTIAL: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    HEDGE: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    LOGICAL: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    PERSON: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    RELATIONAL: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    SEQUENCING: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],
    UNLISTED: [
      { word: "and", count: 6 },
      { word: "but", count: 6 },
      { word: "if", count: 1 },
      { word: "or", count: 1 },
      { word: "though", count: 3 },
      { word: "while", count: 3 },
    ],

  };

  //Dividir los datos obtenidos entre las 3 columnas al expandir la informacion

  public dividedData: DividedData = {};


  divideData() {
    for (const key in this.data) {
      if (this.data.hasOwnProperty(key)) {
        const items = this.data[key];
        const chunkSize = Math.ceil(items.length / 3);
        this.dividedData[key] = [
          items.slice(0, chunkSize),
          items.slice(chunkSize, chunkSize * 2),
          items.slice(chunkSize * 2),
        ];
      }
    }
  }


  activeEyeIcon: HTMLImageElement | null = null;

  constructor() {
    this.divideData();
  }

  //Funcion para expandir cada cuadro
  toggleExpand(identifier: string) {
    this.isExpanded[identifier] = !this.isExpanded[identifier];
  }

  toggleExpandAll() {
    const newState = !this.isExpanded['TOTAL'] || !this.isExpanded['ATTITUDE'] || !this.isExpanded['EMPHATIC'] || !this.isExpanded['EVIDENTIAL'] || !this.isExpanded['HEDGE'] || !this.isExpanded['LOGICAL'] || !this.isExpanded['PERSON'] || !this.isExpanded['RELATIONAL'] || !this.isExpanded['SEQUENCING'] || !this.isExpanded['UNLISTED'];
    this.isExpanded['TOTAL'] = newState;
    this.isExpanded['ATTITUDE'] = newState;
    this.isExpanded['EMPHATIC'] = newState;
    this.isExpanded['EVIDENTIAL'] = newState;
    this.isExpanded['HEDGE'] = newState;
    this.isExpanded['LOGICAL'] = newState;
    this.isExpanded['PERSON'] = newState;
    this.isExpanded['RELATIONAL'] = newState;
    this.isExpanded['SEQUENCING'] = newState;
    this.isExpanded['UNLISTED'] = newState;
  }

  selectMenuItem(menuItem: MenuItem) {
    this.selectedMenuItem = menuItem;
  }

  isSelected(menuItem: MenuItem): boolean {
    return this.selectedMenuItem === menuItem;
  }

  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    scales: {
      x: {
        grid: {
          display: false,  // Ocultar las líneas verticales
        },
      },
      y: {
        min: 0,
        max: 2.5,  // Límite máximo del eje Y en 25%
        ticks: {
          stepSize: .5,  // Incrementos de 5% en 5%
          callback: function (value) {
            return value + '%';  // Mostrar el símbolo % en las etiquetas
          }
        },
        border: {
          display: false  // Eliminar el borde del eje Y
        },
        grid: {
          color: '#E0E0E0',  // Color de las líneas horizontales
        },
      },
    },
    plugins: {
      legend: {
        display: false, // Ocultar la leyenda
      },
      datalabels: {
              display: false // Desactiva los datalabels solo en este gráfico
            },
    },
  };


  public barChartType = 'bar' as const;

  public barChartData: ChartData<'bar'> = {
    labels: ['Attitude Marker', 'Emphatic', 'Evidential', 'Hedge', 'Logical Connective', 'Person Marker', 'Relational Marker', 'Sequencing'],
    datasets: [
      {
        data: [2, .5, .35, .4, .2, .1, .05, .4, .35],
        label: '',
        backgroundColor: [
          '#6C2D8E',  // Naranja
          '#0075FF',  // Verde
          '#1A8583',  // Rojo
          '#F60D16',  // Verde claro
          '#15622B',  // Azul
          '#FF8EC5',  // Púrpura
          '#8E8E5B',
          '#C5C500',

        ],
        // Hace las barras más delgadas
        barThickness: 30,
      },
    ],
  };
}
